import ModuleWrapper from 'shared-lib/containers/Module';

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard');
const SubscriptionCost = () => import(/* webpackChunkName: "dashboard-subscription" */ '@/views/dashboard/SubscriptionCost');
const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Settings');
const meta = (data = {}) => ({
    title: 'Dashboard',
    auth: true,
    ...data,
});

export default [{
    path: '/dashboard',
    component: ModuleWrapper,
    meta: meta(),
    children: [
        {
            path: '',
            name: 'Dashboard',
            component: Dashboard,
            meta: meta({
                permissionsModuleName: 'analytics',
                permission: 'overview',
            }),
        },
        {
            path: 'subscription-cost',
            name: 'SubscriptionCost',
            component: SubscriptionCost,
            meta: meta({
                title: 'Subscription Cost',
                permissionsModuleName: 'subscription',
                permission: 'show',
            }),
        },
        {
            path: 'settings',
            name: 'Settings',
            component: Settings,
            props: true,
            meta: meta({
                title: 'Settings',
                privilegeModule: 'settings',
                permission: 'read',
            }),
        },
    ],
}];
